
const calculateRate = (starts: number, completes: number) => {
  if (starts === 0) return 0;
  return (completes / starts) * 100;
};

const calculateRateDifference = (starts: number, completes: number, difStarts: number, difCompletes: number) => {
  if (starts === 0) return 0;
  return (completes / starts) * 100 - (difCompletes / difStarts) * 100;
};

const calculatePercentChange = (current: number, past: number) => {
  if (current === 0) return 0;
  return ((current - past) / past) * 100;
};

export { calculateRate, calculateRateDifference, calculatePercentChange };